import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Header, Footer, Body, Popup } from '@calendly/ui/components/popup'
import { useDispatch, useSelector } from 'react-redux'

import { fetchCurrentSubscription } from 'features/billing/actions/fetch_current_subscription'
import { removeDowngradeAction } from 'features/billing/actions/remove_scheduled_downgrade'
import { resetCreateSubscription } from 'features/billing/create_subscription_slice'
import { humanizePlan } from 'features/billing/helpers'
import { nextPlanIdSelector, billingDateSelector, nextQuantitySelector, scheduledChangeTypeSelector } from 'features/billing/selectors'
import { useSmallDateFormat } from 'features/billing/stages/hooks/useDateFormat'

import { isFailureSelector, errorSelector, isLoadingSelector } from './selectors'
import { reset as resetPromptToRemoveScheduledDowngrade } from './slice'
import { Paragraph, Error } from './styles'

export const Prompt = () => {
  const dispatch = useDispatch()

  const isLoading = useSelector(isLoadingSelector)
  const isFailure = useSelector(isFailureSelector)
  const error = useSelector(errorSelector)
  const nextPlan = humanizePlan(useSelector(nextPlanIdSelector))
  const nextBillDate = useSmallDateFormat(useSelector(billingDateSelector))
  const scheduledChangeType = useSelector(scheduledChangeTypeSelector)
  const newQuantity = useSelector(nextQuantitySelector)

  const onDowngrade = () => {
    dispatch(removeDowngradeAction())
  }

  const onClose = () => {
    dispatch(resetPromptToRemoveScheduledDowngrade())
    dispatch(resetCreateSubscription())
    dispatch(fetchCurrentSubscription())
  }

  return (
    <Popup onClose={onClose}>
      <Header title={I18n.t('publisher.billing.scheduled_downgrade.prompt_to_remove_modal.title')} />
      <Body>
        <Paragraph>
          {scheduledChangeType === 'plan'
            && I18n.t('publisher.billing.scheduled_downgrade.prompt_to_remove_modal.plan_change',
              {
                new_plan: nextPlan,
                billing_date: nextBillDate
              })}
          {scheduledChangeType === 'quantity'
            && I18n.t('publisher.billing.scheduled_downgrade.prompt_to_remove_modal.quantity_change',
              {
                count: newQuantity,
                billing_date: nextBillDate
              })}
        </Paragraph>
        <Paragraph>
          {I18n.t('publisher.billing.scheduled_downgrade.prompt_to_remove_modal.text2')}
        </Paragraph>
        {
          isFailure && (
            <Error>
              {error}
            </Error>
          )
        }
      </Body>
      <Footer>
        <Button
          decoration="secondary-outline"
          onClick={onClose}
        >
          {I18n.t('publisher.billing.scheduled_downgrade.prompt_to_remove_modal.cancel')}
        </Button>
        <Button onClick={onDowngrade} loading={isLoading}>
          {I18n.t('publisher.billing.scheduled_downgrade.prompt_to_remove_modal.submit')}
        </Button>
      </Footer>
    </Popup>
  )
}
